/* =============================================================
   Thirty Degrees — Shopify Theme JS
   Cart API, search, mobile drawer, PDP interactions
   ============================================================= */

/* ---------- Shopify Cart API ---------- */
const Cart = {
  async get() {
    const res = await fetch('/cart.js');
    return res.json();
  },

  async add(variantId, qty = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    });
    if (!res.ok) throw new Error('Failed to add to cart');
    const data = await res.json();
    await this.updateUI();
    return data;
  },

  async change(line, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: qty })
    });
    const data = await res.json();
    await this.updateUI();
    return data;
  },

  async updateUI() {
    const cart = await this.get();
    // Update bag count in header (text label for desktop)
    document.querySelectorAll('[aria-label="Bag"] .icon-label').forEach(el => {
      el.textContent = 'Bag (' + cart.item_count + ')';
    });
    // Update numeric badge (visible on mobile)
    const badge = document.getElementById('cartCount');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? '' : 'none';
    }
    // Re-render cart drawer if open
    renderCartDrawer(cart);
  }
};

/* ---------- HTML escape helper ---------- */
function escHtml(str) {
  if (!str) return '';
  return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

/* ---------- Format money ---------- */
function formatMoney(cents) {
  var amount = (cents / 100);
  var amountStr = amount.toLocaleString('en-IN');
  var amountNoDecimals = Math.round(amount).toLocaleString('en-IN');
  var amountWithDecimals = amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (window.UTS && window.UTS.moneyFormat) {
    return window.UTS.moneyFormat
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_with_comma_separator}}', amountWithDecimals)
      .replace('{{amount}}', amountStr);
  }
  return '₹ ' + amountNoDecimals;
}

/* Format money from amount in rupees (not cents) — used for Predictive Search API */
function formatMoneyFromAmount(priceStr) {
  var amount = parseFloat(priceStr) || 0;
  var amountNoDecimals = Math.round(amount).toLocaleString('en-IN');
  if (window.UTS && window.UTS.moneyFormat) {
    return window.UTS.moneyFormat
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_with_comma_separator}}', amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
      .replace('{{amount}}', amount.toLocaleString('en-IN'));
  }
  return '₹ ' + amountNoDecimals;
}

/* ---------- Boot ---------- */
document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('header');

  // ---- Announcement Bar Dismiss ----
  const announceBar = document.getElementById('announcementBar');
  const announceClose = document.getElementById('announceClose');
  if (announceBar && announceClose) {
    if (sessionStorage.getItem('announce_dismissed') === '1') {
      announceBar.classList.add('dismissed');
    }
    announceClose.addEventListener('click', () => {
      announceBar.classList.add('dismissed');
      sessionStorage.setItem('announce_dismissed', '1');
    });
  }

  // Force solid header on non-hero pages
  if (header && document.body.dataset.solidHeader === 'true') {
    header.classList.add('force-solid');
  }

  // Scroll state — frosted glass header on scroll
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    onScroll();
  }

  // ---- Mobile Nav Drawer ----
  if (!document.getElementById('mobileDrawer')) {
    // Add hamburger to header
    const inner = document.querySelector('.header__inner');
    if (inner) {
      const hamburger = document.createElement('button');
      hamburger.className = 'nav-toggle';
      hamburger.id = 'navToggle';
      hamburger.setAttribute('aria-label', 'Menu');
      hamburger.innerHTML = '<span></span><span></span>';
      inner.prepend(hamburger);
    }

    // Build drawer from nav links
    const navLinks = document.querySelectorAll('.nav > .nav__item');
    let drawerNav = '';
    navLinks.forEach(item => {
      const mainLink = item.querySelector('a');
      const dropdown = item.querySelector('.nav__dropdown');
      if (dropdown) {
        drawerNav += `<div class="mobile-drawer__group">
          <a href="${mainLink.href}" class="mobile-drawer__heading">${mainLink.textContent}</a>
          <div class="mobile-drawer__links">
            ${Array.from(dropdown.querySelectorAll('a')).map(a => `<a href="${a.href}">${a.textContent}</a>`).join('')}
          </div>
        </div>`;
      } else {
        drawerNav += `<a href="${mainLink.href}" class="mobile-drawer__heading">${mainLink.textContent}</a>`;
      }
    });

    const drawer = document.createElement('div');
    drawer.className = 'mobile-drawer';
    drawer.id = 'mobileDrawer';
    drawer.innerHTML = `
      <div class="mobile-drawer__inner">
        <button class="mobile-drawer__close" id="drawerClose" aria-label="Close menu">&times;</button>
        <nav class="mobile-drawer__nav">${drawerNav}</nav>
        <div class="mobile-drawer__footer">
          <a href="javascript:void(0)" id="drawerSearch">Search</a>
          <a href="/account">Account</a>
        </div>
      </div>
    `;
    document.body.appendChild(drawer);

    const overlay = document.createElement('div');
    overlay.className = 'mobile-drawer__overlay';
    overlay.id = 'drawerOverlay';
    document.body.appendChild(overlay);

    const toggle = document.getElementById('navToggle');
    const close = document.getElementById('drawerClose');
    const olay = document.getElementById('drawerOverlay');
    const dw = document.getElementById('mobileDrawer');
    function openDrawer() { dw.classList.add('open'); olay.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeDrawer() { dw.classList.remove('open'); olay.classList.remove('open'); document.body.style.overflow = ''; }
    if (toggle) toggle.addEventListener('click', openDrawer);
    if (close) close.addEventListener('click', closeDrawer);
    if (olay) olay.addEventListener('click', closeDrawer);
    dw.querySelectorAll('a').forEach(link => link.addEventListener('click', closeDrawer));
  }

  // ---- Search Overlay ----
  if (!document.getElementById('searchOverlay')) {
    const so = document.createElement('div');
    so.className = 'search-overlay';
    so.id = 'searchOverlay';
    so.innerHTML = `
      <button class="search-overlay__close" id="searchClose">&times;</button>
      <form action="/search" method="get" style="width:100%;max-width:600px;">
        <input class="search-overlay__input" id="searchInput" type="text" name="q" placeholder="Search" autocomplete="off">
        <input type="hidden" name="type" value="product">
      </form>
      <div class="search-overlay__results" id="searchResults"></div>
    `;
    document.body.appendChild(so);

    const searchInput = document.getElementById('searchInput');
    const searchResults = document.getElementById('searchResults');

    function openSearch() { so.classList.add('open'); document.body.style.overflow = 'hidden'; setTimeout(() => searchInput.focus(), 100); }
    function closeSearch() { so.classList.remove('open'); document.body.style.overflow = ''; searchInput.value = ''; searchResults.innerHTML = ''; }

    document.getElementById('searchClose').addEventListener('click', closeSearch);
    so.addEventListener('click', e => { if (e.target === so) closeSearch(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && so.classList.contains('open')) closeSearch(); });

    // Wire up header search button
    const headerSearch = document.getElementById('headerSearch');
    if (headerSearch) headerSearch.addEventListener('click', openSearch);

    // Wire up drawer search
    const drawerSearch = document.getElementById('drawerSearch');
    if (drawerSearch) {
      drawerSearch.addEventListener('click', (e) => {
        e.preventDefault();
        const dw = document.getElementById('mobileDrawer');
        const olay = document.getElementById('drawerOverlay');
        if (dw) dw.classList.remove('open');
        if (olay) olay.classList.remove('open');
        document.body.style.overflow = '';
        openSearch();
      });
    }

    // Shopify Predictive Search
    let searchTimer;
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        try {
          const res = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8');
          const data = await res.json();
          const products = data.resources.results.products || [];
          if (products.length === 0) {
            searchResults.innerHTML = '<div class="search-overlay__count">No results for "' + q + '"</div>';
            return;
          }
          searchResults.innerHTML = `
            <div class="search-overlay__count">${products.length} result${products.length === 1 ? '' : 's'}</div>
            <div class="product-grid">${products.map(p => `
              <div class="product">
                <a href="${escHtml(p.url)}" class="product__link">
                  <div class="product__media">
                    <img src="${escHtml(p.image)}" alt="${escHtml(p.title)}" loading="lazy">
                  </div>
                </a>
                <a href="${escHtml(p.url)}" class="product__name">${escHtml(p.title)}</a>
                <div class="product__price">${formatMoneyFromAmount(p.price)}</div>
              </div>
            `).join('')}</div>
          `;
        } catch (err) {
          searchResults.innerHTML = '<div class="search-overlay__count">Search unavailable</div>';
        }
      }, 300);
    });
  }

  // ---- Cart Drawer ----
  if (!document.getElementById('cartDrawer')) {
    const cd = document.createElement('div');
    cd.className = 'cart-drawer';
    cd.id = 'cartDrawer';
    cd.innerHTML = `
      <div class="cart-drawer__header">
        <span class="cart-drawer__title">Your Bag</span>
        <button class="cart-drawer__close" id="cartClose">&times;</button>
      </div>
      <div class="cart-drawer__items" id="cartItems"></div>
      <div class="cart-drawer__footer" id="cartFooter"></div>
    `;
    document.body.appendChild(cd);

    const cOverlay = document.createElement('div');
    cOverlay.className = 'cart-drawer__overlay';
    cOverlay.id = 'cartOverlay';
    document.body.appendChild(cOverlay);

    async function openCart() {
      cd.classList.add('open');
      cOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      const cart = await Cart.get();
      renderCartDrawer(cart);
    }
    function closeCart() { cd.classList.remove('open'); cOverlay.classList.remove('open'); document.body.style.overflow = ''; }

    document.getElementById('cartClose').addEventListener('click', closeCart);
    cOverlay.addEventListener('click', closeCart);

    const headerCart = document.getElementById('headerCart');
    if (headerCart) headerCart.addEventListener('click', openCart);

    // Delegate remove clicks
    document.getElementById('cartItems').addEventListener('click', async (e) => {
      const removeBtn = e.target.closest('.cart-item__remove');
      if (removeBtn) {
        const line = Number(removeBtn.dataset.line);
        await Cart.change(line, 0);
        const cart = await Cart.get();
        renderCartDrawer(cart);
      }
    });
  }

  // ---- Quick Add (PLP) ----
  document.addEventListener('click', function(e) {
    const sizeBtn = e.target.closest('.quick-add__size');
    if (!sizeBtn || sizeBtn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    const card = sizeBtn.closest('.product');
    card.querySelectorAll('.quick-add__size').forEach(b => b.classList.remove('selected'));
    sizeBtn.classList.add('selected');
    const addBtn = card.querySelector('.quick-add__btn');
    addBtn.disabled = false;
    addBtn.textContent = 'Add to Bag';
  });

  document.addEventListener('click', async function(e) {
    const addBtn = e.target.closest('.quick-add__btn');
    if (!addBtn || addBtn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    const card = addBtn.closest('.product');
    const selectedSize = card.querySelector('.quick-add__size.selected');
    if (selectedSize && selectedSize.dataset.variantId) {
      addBtn.textContent = 'Adding...';
      try {
        await Cart.add(Number(selectedSize.dataset.variantId));
        addBtn.textContent = 'Added';
        setTimeout(() => { addBtn.textContent = 'Add to Bag'; }, 1500);
      } catch (err) {
        addBtn.textContent = 'Error';
        setTimeout(() => { addBtn.textContent = 'Add to Bag'; }, 1500);
      }
    }
  });

  // ---- Product Card Swipe (mobile + desktop click) ----
  document.querySelectorAll('.product__media').forEach(media => {
    const imgs = media.querySelectorAll('.product__media-img');
    const dots = media.querySelectorAll('.product__media-dot');
    const segs = media.querySelectorAll('.product__swipe-seg');
    const count = imgs.length;
    if (count < 2) return;

    let currentIdx = 0;

    function showImage(idx) {
      imgs.forEach((img, i) => img.classList.toggle('active', i === idx));
      dots.forEach((dot, i) => dot.classList.toggle('active', i === idx));
      segs.forEach((seg, i) => seg.classList.toggle('active', i === idx));
      currentIdx = idx;
    }

    // Touch swipe
    if ('ontouchstart' in window) {
      let startX = 0;
      let startY = 0;

      // Show dots on mobile always
      const dotsContainer = media.querySelector('.product__media-dots');
      if (dotsContainer) dotsContainer.classList.add('visible');

      media.addEventListener('touchstart', e => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      media.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
          e.preventDefault();
          if (dx < 0) {
            // Swipe left → next image
            showImage((currentIdx + 1) % count);
          } else {
            // Swipe right → previous image
            showImage((currentIdx - 1 + count) % count);
          }
        }
      });
    }
  });

  // ---- Tag-based Color Swatches (browse/collection pages) ----
  // Group product cards by data-color-group and inject swatch links
  (function() {
    var colorGroups = {};
    document.querySelectorAll('.product[data-color-group]').forEach(function(card) {
      var group = card.dataset.colorGroup;
      if (!group) return;
      if (!colorGroups[group]) colorGroups[group] = [];
      var link = card.querySelector('.product__link');
      colorGroups[group].push({
        handle: card.dataset.handle,
        name: card.dataset.colorName || '',
        hex: card.dataset.colorHex || '#ccc',
        url: link ? link.href : '/products/' + card.dataset.handle
      });
    });
    // Inject swatches for groups with 2+ products
    Object.keys(colorGroups).forEach(function(group) {
      var products = colorGroups[group];
      if (products.length < 2) return;
      products.forEach(function(p) {
        var card = document.querySelector('.product[data-handle="' + p.handle + '"] [data-tag-swatches]');
        if (!card) return;
        card.innerHTML = products.map(function(sp) {
          return '<a href="' + escHtml(sp.url) + '" class="product__swatch' +
            (sp.handle === p.handle ? ' active' : '') +
            '" style="background:' + escHtml(sp.hex) +
            '" title="' + escHtml(sp.name) + '"></a>';
        }).join('');
      });
    });
  })();

  // ---- PDP Interactions ----
  // Thumbnail click → scroll to gallery image
  document.querySelectorAll('.pdp__thumb').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = Number(btn.dataset.idx);
      const figures = document.querySelectorAll('.pdp__gallery figure');
      const target = figures[idx];
      if (target) {
        const top = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  // Highlight active thumb on scroll
  const thumbs = document.querySelectorAll('.pdp__thumb');
  const dots = document.querySelectorAll('.pdp__dot');
  const figures = document.querySelectorAll('.pdp__gallery figure');
  if (thumbs.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const idx = Number(e.target.dataset.idx);
          thumbs.forEach(t => t.classList.toggle('active', Number(t.dataset.idx) === idx));
          dots.forEach(d => d.classList.toggle('active', Number(d.dataset.idx) === idx));
        }
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    figures.forEach(f => io.observe(f));
  }

  // Mobile gallery scroll → update dots
  const gallery = document.getElementById('pdpGallery');
  if (gallery) {
    gallery.addEventListener('scroll', () => {
      const idx = Math.round(gallery.scrollLeft / gallery.offsetWidth);
      dots.forEach(d => d.classList.toggle('active', Number(d.dataset.idx) === idx));
    });
    dots.forEach(d => {
      d.addEventListener('click', () => {
        gallery.scrollTo({ left: Number(d.dataset.idx) * gallery.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  // PDP Size selection
  const mainSizes = document.querySelectorAll('.pdp__size');
  const stickySizes = document.querySelectorAll('.sticky-atc__size');
  const addBtn = document.getElementById('addBtn');
  const stickyAddBtn = document.getElementById('stickyAddBtn');
  const variantInput = document.getElementById('variantId');

  function selectSize(btn) {
    const size = btn.dataset.size;
    const variantId = btn.dataset.variantId;
    mainSizes.forEach(b => b.classList.toggle('selected', b.dataset.size === size));
    stickySizes.forEach(b => b.classList.toggle('selected', b.dataset.size === size));
    if (variantInput && variantId) variantInput.value = variantId;
    if (addBtn) { addBtn.textContent = 'Add to Bag'; addBtn.disabled = false; }
    if (stickyAddBtn) { stickyAddBtn.textContent = 'Add to Bag'; stickyAddBtn.disabled = false; }
  }

  mainSizes.forEach(btn => btn.addEventListener('click', () => selectSize(btn)));
  stickySizes.forEach(btn => btn.addEventListener('click', () => selectSize(btn)));

  // PDP Add to Bag via Shopify cart API (intercept form)
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(productForm);
      const variantId = formData.get('id');
      if (!variantId) return;
      if (addBtn) addBtn.textContent = 'Adding...';
      try {
        await Cart.add(Number(variantId));
        if (addBtn) addBtn.textContent = 'Added to Bag';
        if (stickyAddBtn) stickyAddBtn.textContent = 'Added to Bag';
        setTimeout(() => {
          if (addBtn) addBtn.textContent = 'Add to Bag';
          if (stickyAddBtn) stickyAddBtn.textContent = 'Add to Bag';
        }, 2000);
      } catch (err) {
        if (addBtn) addBtn.textContent = 'Error — Try Again';
      }
    });
  }

  // Sticky Add to Bag (mobile)
  if (stickyAddBtn) {
    stickyAddBtn.addEventListener('click', () => {
      if (productForm) productForm.dispatchEvent(new Event('submit'));
    });
  }

  // Hide sticky bar when main Add to Bag is visible
  const stickyAtc = document.getElementById('stickyAtc');
  if (stickyAtc && addBtn && 'IntersectionObserver' in window) {
    const atcObserver = new IntersectionObserver(entries => {
      entries.forEach(e => stickyAtc.classList.toggle('hidden', e.isIntersecting));
    }, { threshold: 0 });
    atcObserver.observe(addBtn);
  }

  // Accordion
  document.querySelectorAll('.pdp__acc-head').forEach(head => {
    head.addEventListener('click', () => head.parentElement.classList.toggle('open'));
  });

  // Size Guide Modal
  const openSg = document.getElementById('openSizeGuide');
  const closeSg = document.getElementById('closeSizeGuide');
  const sgModal = document.getElementById('sizeGuideModal');
  if (openSg && sgModal) {
    openSg.addEventListener('click', e => { e.preventDefault(); sgModal.classList.add('open'); document.body.style.overflow = 'hidden'; });
    if (closeSg) closeSg.addEventListener('click', () => { sgModal.classList.remove('open'); document.body.style.overflow = ''; });
    sgModal.addEventListener('click', e => { if (e.target === sgModal) { sgModal.classList.remove('open'); document.body.style.overflow = ''; } });
  }

  // Find My Size calculator
  const findSizeBtn = document.getElementById('findSizeBtn');
  if (findSizeBtn) {
    const SIZE_CHART = {
      XS: { chest: [32, 33], waist: [25, 26], hip: [35, 36] },
      S:  { chest: [34, 35], waist: [27, 28], hip: [37, 38] },
      M:  { chest: [36, 37], waist: [29, 30], hip: [39, 40] },
      L:  { chest: [38, 39], waist: [31, 32], hip: [41, 42] },
      XL: { chest: [40, 41], waist: [33, 34], hip: [43, 44] }
    };
    findSizeBtn.addEventListener('click', () => {
      const chest = parseFloat(document.getElementById('sgChest').value) || 0;
      const waist = parseFloat(document.getElementById('sgWaist').value) || 0;
      const hip   = parseFloat(document.getElementById('sgHip').value) || 0;
      if (!chest && !waist && !hip) {
        document.getElementById('sgResult').textContent = 'Please enter at least one measurement.';
        return;
      }
      let best = null, bestScore = Infinity;
      for (const [sz, c] of Object.entries(SIZE_CHART)) {
        let score = 0;
        if (chest) score += Math.abs(chest - (c.chest[0] + c.chest[1]) / 2);
        if (waist) score += Math.abs(waist - (c.waist[0] + c.waist[1]) / 2);
        if (hip)   score += Math.abs(hip - (c.hip[0] + c.hip[1]) / 2);
        if (score < bestScore) { bestScore = score; best = sz; }
      }
      document.getElementById('sgResult').innerHTML = 'We recommend size <strong>' + best + '</strong> for you.';
      document.querySelectorAll('.pdp__size').forEach(b => b.classList.toggle('selected', b.dataset.size === best));
    });
  }
});

/* ---------- Cart Drawer Renderer ---------- */
function renderCartDrawer(cart) {
  const itemsEl = document.getElementById('cartItems');
  const footerEl = document.getElementById('cartFooter');
  if (!itemsEl || !footerEl || !cart) return;

  if (!cart.items || cart.items.length === 0) {
    itemsEl.innerHTML = '<div class="cart-drawer__empty">Your bag is empty</div>';
    footerEl.innerHTML = '';
    return;
  }

  itemsEl.innerHTML = cart.items.map((item, i) => `
    <div class="cart-item">
      <div class="cart-item__img">
        ${item.image ? '<img src="' + escHtml(item.image) + '" alt="' + escHtml(item.title) + '">' : ''}
      </div>
      <div class="cart-item__info">
        <div class="cart-item__name">${escHtml(item.product_title)}</div>
        <div class="cart-item__meta">Size: ${escHtml(item.variant_title)} &middot; Qty: ${item.quantity}</div>
        <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
        <button class="cart-item__remove" data-line="${i + 1}">Remove</button>
      </div>
    </div>
  `).join('');

  footerEl.innerHTML = `
    <div class="cart-drawer__subtotal">
      <span class="cart-drawer__subtotal-label">Subtotal</span>
      <span>${formatMoney(cart.total_price)}</span>
    </div>
    <a href="/checkout" class="cart-drawer__checkout" style="display:block;text-align:center;text-decoration:none;">Checkout</a>
    <div class="cart-drawer__note">Free shipping across India</div>
  `;
}

/* ===========================================================
   Size + Colour filter (collection pages) — client-side
   =========================================================== */
(function () {
  var grid = document.getElementById('productGrid');
  var filterBtn = document.getElementById('filterBtn');
  if (!grid || !filterBtn) return;

  var drawer = document.getElementById('filterDrawer');
  var overlay = document.getElementById('filterOverlay');
  var closeBtn = document.getElementById('filterClose');
  var sizesWrap = document.getElementById('filterSizes');
  var colorsWrap = document.getElementById('filterColors');
  var sizeGroup = document.getElementById('filterGroupSize');
  var colorGroup = document.getElementById('filterGroupColor');
  var applyBtn = document.getElementById('filterApply');
  var clearBtn = document.getElementById('filterClear');
  var clearEmpty = document.getElementById('plpClearEmpty');
  var countBadge = document.getElementById('filterCount');
  var chipsWrap = document.getElementById('plpActiveFilters');
  var noResults = document.getElementById('plpNoResults');
  var plpCount = document.getElementById('plpCount');

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.product'));

  // Common fashion colour name -> hex (fallback when a product has no hex tag)
  var COLOR_MAP = {
    black: '#1a1a1a', white: '#ffffff', ivory: '#f4f0e6', cream: '#f3ecdc', beige: '#e3d6c0',
    sand: '#dcc9a8', tan: '#c8a97e', brown: '#6b4f37', chocolate: '#4a3422', camel: '#c19a6b',
    grey: '#8d8d8d', gray: '#8d8d8d', charcoal: '#3a3a3a', silver: '#c8c8c8',
    navy: '#1b2631', blue: '#3b5b86', 'sky blue': '#9bc4e2', teal: '#2a7f7f', denim: '#4a6b8a',
    green: '#4a6b3f', olive: '#7a7d4a', sage: '#9caf88', mint: '#bcdcc4', emerald: '#2e7d52',
    red: '#a32d2d', maroon: '#6e2230', burgundy: '#5c1a2b', wine: '#5c1a2b', rust: '#b06a3b', terracotta: '#c66b4e',
    orange: '#d27d3f', coral: '#e08a6f', peach: '#f2c4a8',
    pink: '#e3a8b8', blush: '#e8c4c8', rose: '#d98a9a', fuchsia: '#c64b7a', magenta: '#b03a6a',
    purple: '#7a5a8a', lilac: '#c3aed6', lavender: '#cdbfe0', mauve: '#a98a9a',
    yellow: '#e6c84a', mustard: '#c9a227', gold: '#c9a84a',
    multicolor: 'conic', multi: 'conic', print: 'conic', printed: 'conic', floral: 'conic', striped: '#cccccc'
  };

  var SIZE_ORDER = ['xxs','xs','s','m','l','xl','xxl','xxxl','free','onesize','one size'];

  // --- collect available sizes + colours from the rendered cards ---
  var sizeSet = {};
  var colorSet = {};   // name -> hex
  cards.forEach(function (card) {
    (card.getAttribute('data-filter-sizes') || '').split(',').forEach(function (s) {
      s = s.trim(); if (s) sizeSet[s] = true;
    });
    var hexHint = (card.getAttribute('data-filter-color-hex') || '').trim();
    (card.getAttribute('data-filter-colors') || '').split(',').forEach(function (c) {
      c = c.trim(); if (!c) return;
      if (!(c in colorSet)) colorSet[c] = hexHint || COLOR_MAP[c] || '';
      else if (!colorSet[c] && hexHint) colorSet[c] = hexHint;
    });
  });

  var sizes = Object.keys(sizeSet).sort(function (a, b) {
    var ia = SIZE_ORDER.indexOf(a), ib = SIZE_ORDER.indexOf(b);
    if (ia === -1 && ib === -1) return a.localeCompare(b, undefined, { numeric: true });
    if (ia === -1) return 1; if (ib === -1) return -1; return ia - ib;
  });
  var colors = Object.keys(colorSet).sort();

  var selSizes = {}, selColors = {};

  function isLight(hex) {
    if (!hex || hex === 'conic' || hex[0] !== '#') return false;
    var h = hex.replace('#', '');
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    var r = parseInt(h.substr(0,2),16), g = parseInt(h.substr(2,2),16), b = parseInt(h.substr(4,2),16);
    return (0.299*r + 0.587*g + 0.114*b) > 210;
  }

  // --- build the drawer UI ---
  if (sizes.length) {
    sizeGroup.hidden = false;
    sizes.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'filter-pill';
      b.textContent = s;
      b.addEventListener('click', function () {
        if (selSizes[s]) { delete selSizes[s]; b.classList.remove('selected'); }
        else { selSizes[s] = true; b.classList.add('selected'); }
        apply();
      });
      b.dataset.size = s;
      sizesWrap.appendChild(b);
    });
  }
  if (colors.length) {
    colorGroup.hidden = false;
    colors.forEach(function (c) {
      var hex = colorSet[c];
      var wrap = document.createElement('button');
      wrap.type = 'button';
      wrap.className = 'filter-color';
      wrap.dataset.color = c;
      var dot = document.createElement('span');
      dot.className = 'filter-color__dot' + (isLight(hex) ? ' filter-color__dot--light' : '');
      if (hex === 'conic') dot.style.background = 'conic-gradient(#e08a6f,#e6c84a,#9caf88,#3b5b86,#c64b7a,#e08a6f)';
      else dot.style.background = hex || '#cccccc';
      var name = document.createElement('span');
      name.className = 'filter-color__name';
      name.textContent = c;
      wrap.appendChild(dot); wrap.appendChild(name);
      wrap.addEventListener('click', function () {
        if (selColors[c]) { delete selColors[c]; wrap.classList.remove('selected'); }
        else { selColors[c] = true; wrap.classList.add('selected'); }
        apply();
      });
      colorsWrap.appendChild(wrap);
    });
  }

  // --- apply filters to the grid ---
  function apply() {
    var sKeys = Object.keys(selSizes), cKeys = Object.keys(selColors);
    var visible = 0;
    cards.forEach(function (card) {
      var cs = (card.getAttribute('data-filter-sizes') || '');
      var cc = (card.getAttribute('data-filter-colors') || '');
      var okS = !sKeys.length || sKeys.some(function (s) { return (',' + cs + ',').indexOf(',' + s + ',') > -1; });
      var okC = !cKeys.length || cKeys.some(function (c) { return (',' + cc + ',').indexOf(',' + c + ',') > -1; });
      var show = okS && okC;
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    var total = sKeys.length + cKeys.length;
    if (total) { countBadge.hidden = false; countBadge.textContent = total; }
    else { countBadge.hidden = true; }
    if (plpCount) plpCount.textContent = visible + ' ' + (visible === 1 ? 'piece' : 'pieces');
    applyBtn.textContent = visible ? ('Show ' + visible + ' result' + (visible === 1 ? '' : 's')) : 'No results';
    noResults.hidden = visible !== 0;
    grid.style.display = visible === 0 ? 'none' : '';
    renderChips();
  }

  function renderChips() {
    var html = '';
    Object.keys(selSizes).forEach(function (s) {
      html += '<button type="button" class="plp-chip" data-type="size" data-val="' + s + '">' + s.toUpperCase() + '<span class="plp-chip__x">&times;</span></button>';
    });
    Object.keys(selColors).forEach(function (c) {
      html += '<button type="button" class="plp-chip" data-type="color" data-val="' + c + '">' + c + '<span class="plp-chip__x">&times;</span></button>';
    });
    if (html) html += '<button type="button" class="plp-chip plp-chip--clear" id="chipClearAll">Clear all</button>';
    chipsWrap.innerHTML = html;
    chipsWrap.hidden = !html;
  }

  chipsWrap.addEventListener('click', function (e) {
    var chip = e.target.closest('.plp-chip');
    if (!chip) return;
    if (chip.id === 'chipClearAll') { clearAll(); return; }
    var type = chip.dataset.type, val = chip.dataset.val;
    if (type === 'size') { delete selSizes[val]; var pb = sizesWrap.querySelector('[data-size="' + val + '"]'); if (pb) pb.classList.remove('selected'); }
    else { delete selColors[val]; var cb = colorsWrap.querySelector('[data-color="' + CSS.escape(val) + '"]'); if (cb) cb.classList.remove('selected'); }
    apply();
  });

  function clearAll() {
    selSizes = {}; selColors = {};
    sizesWrap.querySelectorAll('.selected').forEach(function (el) { el.classList.remove('selected'); });
    colorsWrap.querySelectorAll('.selected').forEach(function (el) { el.classList.remove('selected'); });
    apply();
  }

  // --- open / close ---
  function open() { drawer.classList.add('open'); overlay.classList.add('open'); filterBtn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }
  function close() { drawer.classList.remove('open'); overlay.classList.remove('open'); filterBtn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
  filterBtn.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  applyBtn.addEventListener('click', close);
  if (clearBtn) clearBtn.addEventListener('click', clearAll);
  if (clearEmpty) clearEmpty.addEventListener('click', clearAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });

  // hide the filter button entirely if there's nothing to filter
  if (!sizes.length && !colors.length) { filterBtn.style.display = 'none'; }
})();
